export default __webpack_public_path__ + "assets/a5875e.svg";